import { Interval } from "./Workout";

class ZoneProvider
{
    private static zones: number[] = [55, 75, 90, 105, 120];    
    GetZoneForPower(power: number): number
    {
        for (var i = 0; i < ZoneProvider.zones.length; i++)
        {
            if (power < ZoneProvider.zones[i])
            {
                return i;
            }
        }
        return ZoneProvider.zones.length;
    }
}

export class ColorProvider
{
    // gray, blue, green, yellow, orange, red 
    color2 = ['#555555', '#052c5c', '#2f5c05', '#5c3305', '#5c3605', '#5c0505']; // S: 90, L: 19
    color3 = ['#555555', '#09b31d', '#09b31d', '#b3ad09', '#b36609', '#b30909']; // S: 90, L: 37
    
    // blue, green, yellow, orange, red
    hues = [215, 120, 60, 36, 0];
    colors = [this.HSLToRGB(0, 0, 30), ...this.hues.map(hue => this.HSLToRGB(hue, 60, 30))];

    zoneProvider = new ZoneProvider();
    
    getIntervalColor(interval: Interval): string {
        const power = interval.TargetPower ?? (interval.TargetPowerVariation![0] ?? 0 + interval.TargetPowerVariation![1] ?? 0) / 2;
        const zone = this.zoneProvider.GetZoneForPower(power);
        return this.colors[zone];
    }

    HSLToRGB(h: number, s: number, l: number): string {
        // Must be fractions of 1
        s /= 100;
        l /= 100;
      
        const c = (1 - Math.abs(2 * l - 1)) * s;
        const x = c * (1 - Math.abs((h / 60) % 2 - 1));
        const m = l - c / 2;
      
        let r = 0;
        let g = 0;
        let b = 0;
      
        if (0 <= h && h < 60) {
          r = c;
          g = x;
          b = 0;
        } else if (60 <= h && h < 120) {
          r = x;
          g = c;
          b = 0;
        } else if (120 <= h && h < 180) {
          r = 0;
          g = c;
          b = x;
        } else if (180 <= h && h < 240) {
          r = 0;
          g = x;
          b = c;
        } else if (240 <= h && h < 300) {
          r = x;
          g = 0;
          b = c;
        } else if (300 <= h && h < 360) {
          r = c;
          g = 0;
          b = x;
        }
      
        // Having obtained RGB, convert channels to hex
        const rString = Math.round((r + m) * 255).toString(16);
        const gString = Math.round((g + m) * 255).toString(16);
        const bString = Math.round((b + m) * 255).toString(16);
      
        // Prepend 0s, if necessary
        const rStringPadded = rString.length === 1 ? "0" + rString : rString;
        const gStringPadded = gString.length === 1 ? "0" + gString : gString;
        const bStringPadded = bString.length === 1 ? "0" + bString : bString;
      
        return "#" + rStringPadded + gStringPadded + bStringPadded;
    }
}